export enum BindPaymentType {
  ALI_PAY = 1,
  BANK_CARD,
}
export enum BindPaymentStep {
  UPLOAD = 'upload',
  RESULT = 'result',
  NOT_REAL_NAME = 'notRealName',
}
